const { gql } = require('graphql-tag');

module.exports = gql`
query getPersonalizedDiscounts($cohortTier: String!) {
  cartDiscount(key: $cohortTier) {
    value {
      ...on RelativeDiscountValue {
        permyriad
      }
    }
    target {
      ... on LineItemsTarget {
        predicate
      }
    }
    storesRef {
      key
      typeId
    }
    isActive
  }
}
`;
